module.exports = __webpack_public_path__ + "img/hdmi.7ac4e9a0.png";